@if (tree) {
  <app-spirit-tree [tree]="tree"></app-spirit-tree>
}
